var _defs, _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomCameraFlash = function SvgCustomCameraFlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "custom-camera-flash_svg__Layer_1",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".custom-camera-flash_svg__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.75px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1 5.77H6.78c-.11 0-.21.06-.25.16l-.76 1.86c-.04.1-.14.16-.25.16H2.01c-.56 0-1.01.43-1.01.96v11.97c0 .53.45.96 1.01.96h17.67c.56 0 1.01-.43 1.01-.96v-6.39",
    className: "custom-camera-flash_svg__cls-1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.84,
    cy: 15.2,
    r: 3.72,
    className: "custom-camera-flash_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 8.2c2.98 0 5.39-2.71 5.39-6.05 0 3.34 2.41 6.05 5.39 6.05-2.98 0-5.39 2.71-5.39 6.05 0-3.34-2.41-6.05-5.39-6.05Z",
    className: "custom-camera-flash_svg__cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.22 8.2c2.98 0 5.39-2.71 5.39-6.05M17.61 2.15c0 3.34 2.41 6.05 5.39 6.05M17.61 14.25c0-3.34-2.41-6.05-5.39-6.05M23 8.2c-2.98 0-5.39 2.71-5.39 6.05",
    className: "custom-camera-flash_svg__cls-1"
  })));
};
export default SvgCustomCameraFlash;